export default {
    email: void 0,
    organization: void 0,
    global_role: void 0,
    first_name: void 0, //optional
    last_name: void 0, //optional
    suspended: false, //optional
};
